import { BaseService } from "services/_baseService";

class TourScheduleService extends BaseService<any> {
  constructor() {
    super(`tour-schedules`);
  }
}

export default new TourScheduleService();
